import React from 'react';
import { Row, Col } from 'antd';


const Login = () => {
    return (
        <>
            <h1 style={{ align: 'center' }}>  Для создания сайта Вам надо зарегистрироваться </h1>
            <Row justify="space-between">
                <Col md={{ span: 10 }} xs={{ span: 24 }}>
                    <p>Это надо для того, что бы пользователь имел доступ к редактированию только своего сайта.</p>
                    <p>Большинству приложений необходимо знать личность пользователя. Знание личности пользователя позволяет приложению безопасно сохранять пользовательские данные в облаке и обеспечивать одинаковую персонализированную работу на всех устройствах пользователя.</p>
                    <p>Для хранения данных о пользователях используется Firebase Authentication.</p>
                </Col>
                <Col md={{ span: 10 }} xs={{ span: 24 }}>
                    <img src="https://firebase.google.com/images/social.png" alt="firebase"
                        style={{ width: '100%' }} />
                </Col>
            </Row>
            <h2>После регистрации Вам будет доступно больше возможностей.</h2>
            <p>С наилучшими пожеланияи. Администрация.</p>
        </>
    );
}

export default React.memo(Login);